<div class="global-add guts-p-full-1 tw-rounded-lg tw-bg-white">
  <!--
    PD-130899: `inputActions` can now be empty (ReBAC denies `addContent` and the
    user may not create a pathway). `dgx-global-add-buttons` renders a bare empty
    <ul>, so without this guard the heading and description would sit above
    nothing.
  -->
  @if (inputActions.length) {
    <section>
      <h2 class="up-me zeta guts-m-b-half js-a11y-focus" tabindex="-1">
        {{ i18n.dgGlobalAdd_Content }}
      </h2>
      <p class="guts-m-b-half">{{ i18n.dgGlobalAdd_Description }}</p>
      <dgx-global-add-buttons
        [actions]="inputActions"
        type="inputs"
      ></dgx-global-add-buttons>
    </section>
  }
  @if (outcomeActions) {
    <section class="guts-m-t-1">
      <h2 class="up-me zeta guts-m-b-half">
        {{ i18n.dgGlobalAdd_Achievement }}
      </h2>
      <p class="guts-m-b-half">
        {{ i18n.dgGlobalAdd_AchievementDescription }}
      </p>
      <dgx-global-add-buttons
        [actions]="outcomeActions"
        type="outcomes"
      ></dgx-global-add-buttons>
    </section>
  }
  <section class="guts-m-v-1">
    @if (extensionsText) {
      <p
        class="epsilon guts-p-full-1 border-bottom not-last"
        [innerHTML]="extensionsText"
      ></p>
    }
    @if (showIntegrationsSection) {
      <p class="epsilon guts-p-full-1" [innerHTML]="integrationsText"></p>
    }
  </section>
</div>
